export default class globalNavi{
    constructor(pageID,param){

        // fryingpanのときだけヘッダーの表示条件分岐
        this.isFryingpan = document.body.classList.contains('page-fryingpan')
        this.isFryingpanTop = document.getElementById('fryingpan') || document.getElementById('oven_pot_round') || document.getElementById('ricepot')

        /* 必要なDOM */
        this.header = document.getElementById('l-header');
        this.headerBody = document.getElementById('l-header-body');
        this.headerTranslated = document.getElementById(this.isFryingpan ? 'l-header__inner' : 'l-header');
        if(document.getElementById('p-kv')){
            this.kv = document.getElementById('p-kv');
        }
        if(document.querySelector('.c-lowlayer-kv')){
            this.kv = document.querySelector('.c-lowlayer-kv');
        }

        this.hoverTrigger = document.querySelectorAll("#l-header .js__dd-trigger");
        this.hoverContent = document.querySelectorAll('#l-header .js__acc-content-sp');

        //top body用
        this.hoverBodyTrigger = document.querySelectorAll("#l-header-body .js__dd-trigger");
        this.hoverBodyContent = document.querySelectorAll('#l-header-body .js__acc-content-sp');

        this.btn = document.getElementById('l-header-btn');
        this.naviContent = document.getElementById('l-header__navi');
        this.spshowContent = document.querySelectorAll('#l-header .js__sp-show');

        this.onlineBtn = document.getElementById('c-online-btn');
        this.pageTop = document.querySelector('#c-pagetop.pc');

        /* 設定 */
        this.conf = {
        }

        /* ステータス */
        this.status = {
            now : "close",
            device : ( window.innerWidth>param.breakpoint )?"pc":"sp",
            type : "top",
            position : 0,
            isHover : [],
        }

        this.param = param;
        this.pageID = pageID;

        this.init(pageID);
        if(window.innerWidth>param.breakpoint){
            this.set("pc");
        }else{
            this.set("sp");
        }

        TweenMax.set([this.header,this.headerBody], {
            opacity:1,
        });
        TweenMax.set([this.onlineBtn,this.pageTop], {
            x: 155,
            opacity:1,
        });

    }
    init() {
        // fryingpanのときだけヘッダーの表示条件分岐
        if(document.getElementById('fryingpan') || document.getElementById('oven_pot_round') || document.getElementById('ricepot')) {
            TweenMax.set('.fryingpan_header', { yPercent: -100 })
            this.isHeaderShown = false
        }

        this.update();

        let _length = this.hoverTrigger.length;

        // hover
        for(var i = 0 ; i < _length ; i++){
            let _index = i;
            this.hoverTrigger[_index].onmouseenter = () => {
                if (this.status.isHover[_index]) return
                this.status.isHover[_index] = true
                this.list('on',_index);
            };
            this.hoverTrigger[_index].onmouseleave = () => {
                if (!this.status.isHover[_index]) return
                this.status.isHover[_index] = false
                this.list('out',_index);
            };
        }

        let _bodylength = this.hoverBodyTrigger.length;

        // hover
        for(var i = 0 ; i < _bodylength ; i++){
            let _index = i;
            this.hoverBodyTrigger[_index].onmouseenter = () => {
                if (this.status.isHover[_index]) return
                this.status.isHover[_index] = true
                this.listBody('on',_index);
            };
            this.hoverBodyTrigger[_index].onmouseleave = () => {
                if (!this.status.isHover[_index]) return
                this.status.isHover[_index] = false
                this.listBody('out',_index);
            };
        }

        //click
        this.btn.onclick = () => {
            if(this.status.now === 'close'){
                this.status.now = 'open';
                this.status.position = window.pageYOffset || document.documentElement.scrollTop;
                this.btn.classList.add('is-close');
                document.querySelector('#l-header-btn .text').innerHTML = 'Close';
                this.header.classList.add('is-open');
            }else{
                this.status.now = 'close';
                this.btn.classList.remove('is-close');
                document.querySelector('#l-header-btn .text').innerHTML = 'Menu';
                this.header.classList.remove('is-open');
            }
            this.navi();
        };

    }

    list(mode,index){ // グローバルナビゲーション内メニューの表示非表示

        if(this.status.device !== 'pc') return;
        switch(mode){
            case "on":
                TweenMax.killTweensOf(this.hoverContent[index].children , {
                    opacity : true,
                    x : true,
                });
                TweenMax.set(this.hoverContent[index].children , {
                    opacity : 0,
                    x : -50,
                });
                TweenMax.set(this.hoverContent[index] , {
                    display: 'block',
                    onComplete:() => {
                        if (!this.status.isHover[index]) return
                        TweenMax.staggerTo(this.hoverContent[index].children ,0.5, {
                            delay:0.3,
                            opacity : 1,
                            x : 0,
                            ease: Power1.easeOut,
                        },0.06);
                    }
                });
                break;
            case "out":
                if(index === 'all'){
                    let _length = this.hoverContent.length;
                    for(let i = 0 ; i < _length ; i++){
                        this.status.isHover[i] = false
                        TweenMax.killTweensOf(this.hoverContent[i].children , {
                            opacity : true,
                        });
                        TweenMax.to(this.hoverContent[i].children ,0.1, {
                            opacity : 0,
                            ease: Power1.easeOut,
                            onComplete:() => {
                                if (this.status.isHover[i]) return
                                TweenMax.set(this.hoverContent[i] , {
                                    display: 'none',
                                });
                            }
                        });
                    }
                }else{
                    TweenMax.killTweensOf(this.hoverContent[index].children , {
                        opacity : true,
                    });
                    TweenMax.to(this.hoverContent[index].children ,0.2, {
                        delay:0.2,
                        opacity : 0,
                        ease: Power1.easeOut,
                        onComplete:() => {
                            if (this.status.isHover[index]) return
                            TweenMax.set(this.hoverContent[index] , {
                                display: 'none',
                            });
                        }
                    });
                }
                break;
        }

    }

    listBody(mode,index){ // グローバルナビゲーション内メニューの表示非表示

        if(this.status.device !== 'pc') return;
        switch(mode){
            case "on":
                let _length = this.hoverBodyContent.length;
                for(let i = 0 ; i < _length ; i++){
                    TweenMax.killTweensOf(this.hoverBodyContent[index].children , {
                        opacity : true,
                        x : true,
                    });
                    TweenMax.set(this.hoverBodyContent[index].children , {
                        opacity : 0,
                        x : -50,
                    });
                    TweenMax.set(this.hoverBodyContent[index] , {
                        display: 'block',
                        onComplete:() => {
                            if (!this.status.isHover[index]) return
                            TweenMax.staggerTo(this.hoverBodyContent[index].children ,0.5, {
                                delay:0.3,
                                opacity : 1,
                                x : 0,
                                ease: Power1.easeOut,
                            },0.06);
                        }
                    });
                }
                break;
            case "out":
                if(index === 'all'){
                    let _length = this.hoverBodyContent.length;
                    for(let i = 0 ; i < _length ; i++){
                        this.status.isHover[i] = false
                        TweenMax.killTweensOf(this.hoverBodyContent[i].children , {
                            opacity : true,
                        });
                        TweenMax.to(this.hoverBodyContent[i].children ,0.2, {
                            opacity : 0,
                            ease: Power1.easeOut,
                            onComplete:() => {
                                if (this.status.isHover[i]) return
                                TweenMax.set(this.hoverBodyContent[i] , {
                                    display: 'none',
                                });
                            }
                        });
                    }
                }else{
                    TweenMax.killTweensOf(this.hoverBodyContent[index].children , {
                        opacity : true,
                    });
                    TweenMax.to(this.hoverBodyContent[index].children ,0.2, {
                        delay:0.2,
                        opacity : 0,
                        ease: Power1.easeOut,
                        onComplete:() => {
                            if (this.status.isHover[index]) return
                            TweenMax.set(this.hoverBodyContent[index] , {
                                display: 'none',
                            });
                        }
                    });
                }
                break;
        }

    }

    navi(){ // spグローバルナビの表示非表示

        switch(this.status.now) {
            case "open":
                TweenMax.set(this.spshowContent,{
                    opacity : 0,
                    x : -100
                });
                TweenMax.set(this.naviContent , {
                    display : 'block',
                    opacity : 1,
                    onComplete: () => {
                        TweenMax.set("#l-header__navi", { height: window.innerHeight })
                        TweenMax.staggerTo(this.spshowContent ,.6, {
                            opacity : 1,
                            ease: Power2.easeOut
                        },0.08);
                        TweenMax.staggerTo(this.spshowContent ,0.3, {
                            x : 0,
                            ease: Power2.easeOut,
                        },0.08, function(){
                            document.body.classList.add('is-no-scroll');
                            TweenMax.set("#l-header__navi", { height: window.innerHeight })
                        });
                    }
                });
                break;
            case "close":
                document.body.classList.remove('is-no-scroll');
                TweenMax.set("#l-header__navi", { height: 'auto' })
                TweenMax.to(this.spshowContent ,0.4, {
                    opacity : 0,
                    x : -20,
                    ease: Power2.easeIn,
                    onStart: () => {
                        TweenMax.to(window, 0, {scrollTo:this.status.position,autoKill:false});
                    }
                });
                TweenMax.to(this.naviContent ,0.4, {
                    delay:0.3,
                    display : 'none',
                    opacity : 0,
                    ease: Power2.easeIn,
                });
                break;
        }
    }

    update(_y){ // 白黒を切替える処理

        if(document.getElementById('p-kv') || document.querySelector('.c-lowlayer-kv')) {
            // fryingpanのときだけヘッダーの表示条件分岐
            if(this.isFryingpanTop) {
                if (_y > 0) {
                    if(!this.isHeaderShown) {
                        this.isHeaderShown = true
                        this.fryingpanHeaderShow('show');
                    }
                }else{
                    this.fryingpanHeaderShow('hide');
                    this.isHeaderShown = false
                }
            }

            // fixed
            if (_y > this.kv.clientHeight) {
                this.header.classList.remove('type-white');
                this.header.classList.remove('type-logo');
                this.header.classList.add('type-fixed');
                if (this.status.type === 'fixed') return;
                this.status.type = 'fixed';
                if (this.status.device === 'pc') {
                    TweenMax.set(this.headerTranslated, {
                        y: -70,
                        onComplete: () => {
                            TweenMax.to(this.headerTranslated, 0.5, {
                                delay: 0.1,
                                y: 0,
                                ease: Power1.easeOut,
                            });
                        }
                    });
                    this.pagetopShow('show');
                }
            } else {
                if(this.status.type === 'fixed'){
                    this.pagetopShow('hide');
                }
                this.status.type = 'top';
                this.header.classList.add('type-white');
                this.header.classList.remove('type-fixed');
                if(this.pageID === 'top'){
                    this.header.classList.add('type-logo');
                }
            }
        }else{
            if (_y > 0) {
                this.pagetopShow('show');
            }else{
                this.pagetopShow('hide');
            }
        }

        if(this.pageID === 'info'||this.pageID === 'privacy'){
            this.header.classList.remove('type-white');
        }
    }

    pagetopShow(type){
        if(type === 'show'){
            TweenMax.to([this.onlineBtn,this.pageTop], 0.7, {
                x: 0,
                ease: Power2.easeInOut,
            });
        }else{
            TweenMax.to([this.onlineBtn,this.pageTop], 0.7, {
                x: 155,
                ease: Power2.easeInOut,
            });
        }
    }

    fryingpanHeaderShow(type){
        if(type === 'show'){
            TweenMax.to('.fryingpan_header', 0.7, {
                yPercent : 0,
                ease: Power2.easeInOut,
            });
        }else{
            TweenMax.to('.fryingpan_header', 0.7, {
                yPercent: -100,
                ease: Power2.easeInOut,
            });
        }
      }

    set(type){ // pcサイズ、spサイズリサイズによる初期化

        this.status.now = 'close';

        let _length = this.spshowContent.length;
        for(var i = 0 ; i < _length ; i++){
            this.spshowContent[i].removeAttribute('style');
        }

        switch(type) {
            case "pc":
                this.header.classList.remove('is-open');
                for(var i = 0 ; i < this.hoverTrigger.length ; i++){
                    this.hoverTrigger[i].classList.remove('is-open');
                }
                TweenMax.set(this.naviContent , {
                    display: 'block',
                    opacity : 1,
                });
                break;
            case "sp":
                TweenMax.set(this.naviContent , {
                    display: 'none',
                    opacity : 0,
                });
                break;
        }

    }

    scroll(){
        if(this.param.userAgent !== 'tablet') return;
        this.list('out','all');
        if(this.pageID === 'top'){
            this.listBody('out','all');
        }
    }

    resize(_w,_h){
        if(_w>this.param.breakpoint){
            if(this.status.device==="sp") this.set("pc");
            this.status.device = "pc";
        }else{
            if(this.status.device==="pc") this.set("sp");
            this.status.device = "sp";
            if(this.status.now==="open"){
                TweenMax.set("#l-header__navi", { height: window.innerHeight })
            }
        }

    }
}